/**
 * 只存在 localStorage 的畫面偏好（data-model 8.2）。
 * 這些資料不匯出、不匯入，遺失無害，因此所有存取都必須容錯。
 */
export const UI_PREFERENCE_KEYS = [
  'ui.sidebar.collapsed',
  'ui.assistant.collapsed',
  'ui.board.scrollLeft',
  'ui.board.mode',
  'ui.taskList.sort',
  'ui.import.lastSource',
] as const;

export type UiPreferenceKey = (typeof UI_PREFERENCE_KEYS)[number];

export function readUiPreference<T>(key: UiPreferenceKey, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeUiPreference<T>(key: UiPreferenceKey, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // 畫面偏好寫入失敗不影響工作，安靜略過。
  }
}

/** 清除瀏覽器資料時使用；只動 8.2 列出的鍵。 */
export function clearUiPreferences(): void {
  for (const key of UI_PREFERENCE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // 同上。
    }
  }
}
